import {Box, Stack} from '@mui/material';
import {ConvertBoardViewSummaryToValues} from 'global';
import {useItemDataHelper} from 'hooks';
import parser from 'html-react-parser';
import {BoardView, ItemSummaryBuildInVariablesEnums} from 'models/board';
import {ItemDataResponse} from 'models/board/itemData';
import React, {useMemo} from 'react';
import {ItemSummaryTimeTrackerCounter} from '../../Common/ItemSummaryTimeTrackerCounter';

interface KanbanItemProps {
    item: ItemDataResponse;
    selectedBoardView: BoardView;
    itemClickHandler: (item: ItemDataResponse) => void;
}

export const KanbanItem: React.FC<KanbanItemProps> = ({item, selectedBoardView, itemClickHandler}) => {
    const {getItemDataSummaryVariablesList} = useItemDataHelper();

    const itemSummary = useMemo(() => {
        if (!selectedBoardView) {
            console.error('No selected baord in item data');
            return '';
        }
        const selectedView = item.summaryViews.find(x => x.uniqueId === selectedBoardView.id);
        const itemSummaryVariablesList = getItemDataSummaryVariablesList(item);
        const itemSummary = ConvertBoardViewSummaryToValues(itemSummaryVariablesList, selectedView?.value ?? '');
        return itemSummary;
    }, [item.data, selectedBoardView]);

    return (
        <Box onClick={() => itemClickHandler(item)}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Box
                    sx={{
                        width: '100%',
                        display: 'inline-block',
                        overflow: 'hidden',
                        verticalAlign: 'middle',
                        cursor: 'pointer',
                    }}
                >
                    <div>
                        {parser(itemSummary, {
                            replace: domNode => {
                                if (domNode.type === 'text') {
                                    const content = domNode.data;
                                    if (
                                        content.includes(ItemSummaryBuildInVariablesEnums.timeTrackerCounter.toString())
                                    ) {
                                        return <ItemSummaryTimeTrackerCounter itemDataId={item.id} />;
                                    }
                                }
                            },
                        })}
                    </div>
                </Box>
            </Stack>
        </Box>
    );
};

export default KanbanItem;
